(() => {
  'use strict';
  const banner = document.getElementById('NanitPrivacy');
  if (!banner) return;
  const choices = document.getElementById('NanitPrivacyChoices');
  const status = banner.querySelector('[role="status"]');
  const purposes = ['analytics', 'marketing', 'preferences'];
  const marker = 'nanit-privacy-choice-v1';
  let api;
  let returnFocus;
  function recorded() { try { return localStorage.getItem(marker) === '1'; } catch { return false; } }
  function syncGoogle() {
    if (!api) return;
    window.dataLayer = window.dataLayer || [];
    const gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    const marketing = api.marketingAllowed();
    gtag('consent', 'update', {
      analytics_storage: api.analyticsProcessingAllowed() ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing && api.saleOfDataAllowed() ? 'granted' : 'denied',
      functionality_storage: api.preferencesProcessingAllowed() ? 'granted' : 'denied',
      security_storage: 'granted'
    });
  }
  function show(focus) {
    if (!api) return;
    const consent = api.currentVisitorConsent();
    for (const key of purposes) choices.querySelector(`[name="${key}"]`).checked = consent[key] === 'yes';
    banner.hidden = false;
    if (focus) { returnFocus = document.activeElement; banner.querySelector('button').focus(); }
  }
  function save(value) {
    if (!api) return;
    status.hidden = true;
    banner.querySelectorAll('button').forEach(button => { button.disabled = true; });
    // Only a visitor's button click reaches this call. Never reset or grant consent on load.
    // Data-sale/GPC settings are independent and are intentionally not overwritten.
    api.setTrackingConsent(value, error => {
      banner.querySelectorAll('button').forEach(button => { button.disabled = false; });
      if (error) { status.textContent = 'Your choice could not be saved. Please try again.'; status.hidden = false; return; }
      try { localStorage.setItem(marker, '1'); } catch { /* The Shopify choice still persists. */ }
      syncGoogle(); banner.hidden = true; returnFocus?.focus();
    });
  }
  banner.addEventListener('click', event => {
    const button = event.target.closest('[data-privacy]');
    if (!button) return;
    const action = button.dataset.privacy;
    if (action === 'customize') {
      choices.hidden = !choices.hidden;
      button.setAttribute('aria-expanded', String(!choices.hidden));
      banner.querySelector('[data-privacy="save"]').hidden = choices.hidden;
    } else if (action === 'accept' || action === 'reject') {
      save(Object.fromEntries(purposes.map(key => [key, action === 'accept'])));
    } else if (action === 'save') {
      save(Object.fromEntries(purposes.map(key => [key, choices.querySelector(`[name="${key}"]`).checked])));
    }
  });
  function ready(error) {
    if (error || !window.Shopify?.customerPrivacy) return;
    api = window.Shopify.customerPrivacy;
    const footer = document.querySelector('footer .footer__aside') || document.querySelector('footer');
    if (footer && !document.getElementById('NanitPrivacyOpen')) {
      const button = document.createElement('button');
      button.id = 'NanitPrivacyOpen'; button.type = 'button'; button.textContent = 'Cookie preferences';
      button.addEventListener('click', () => show(true)); footer.appendChild(button);
    }
    syncGoogle();
    const consent = api.currentVisitorConsent();
    const unknown = purposes.every(key => consent[key] === '');
    const legacyDenied = purposes.every(key => consent[key] === 'no') && !recorded();
    // Legacy denied choices remain denied until the visitor actively makes a new choice.
    // In custom-banner regions Shopify may still request its own banner after a
    // complete choice. Honour the saved choice; an expired/cleared consent still
    // reopens the banner through `unknown`, and the footer always permits changes.
    if (unknown || legacyDenied || (api.shouldShowBanner() && !recorded())) show(false);
  }
  document.addEventListener('visitorConsentCollected', syncGoogle);
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], ready);
  else if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') ready();
})();
